<template>
	<div
		class="popup-holder"
		:class="{ opened: isVisible }"
		v-click-outside="hideByClick"
	>
		<span class="popup-opener" @click="toggle">
			<slot name="opener" />
		</span>
		<transition name="fade">
			<div v-if="isVisible" class="popup">
				<slot name="content" />
			</div>
		</transition>
	</div>
</template>

<script>
import { clickOutside } from '../../utils/helpers'

export default {
	name: 'Popup',

	directives: {
		'click-outside': clickOutside
	},

	props: {
		shouldShow: {
			type: Number,
			default: 0
		},
		shouldHide: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			isVisible: false
		}
	},

	watch: {
		shouldShow() {
			this.show()
		},
		shouldHide() {
			this.hide()
		}
	},

	methods: {
		hideByClick(e) {
			const { currentTarget } = e
			let { target } = e

			while (target && target !== currentTarget) {
				const isOpener = target.classList.contains('popup-opener')

				if (isOpener) {
					return false
				} else {
					if (target.classList.contains('popup-holder')) {
						this.hide()
					}
					target = target.parentNode
				}
			}

			this.hide()
		},

		show() {
			this.isVisible = true
			this.$emit('change-visibility', this.isVisible)
		},

		hide() {
			this.isVisible = false
			this.$emit('change-visibility', this.isVisible)
		},

		toggle() {
			this.isVisible = !this.isVisible
			this.$emit('change-visibility', this.isVisible)
		}
	}
}
</script>

<style lang="scss">
.popup-holder {
	position: relative;

	&.opened .popup-opener:after {
		top: 18px;
		transform: rotate(225deg);
	}
}

.popup {
	position: absolute;
	bottom: calc(100% + 6px);
	left: 0;
	padding: 16px;
	width: 420px;
	background: #fff;
	border-radius: 6px;
	box-shadow: 0 0 16px 3px rgba(0, 0, 0, 0.3);
	z-index: 1000;
}

.popup-opener {
	display: block;
	min-height: 32px;
	padding: 6px 24px 6px 1px;
	color: #1d1b25;
	position: relative;
	cursor: pointer;

	&:after {
		position: absolute;
		right: 10px;
		top: 11px;
		width: 5px;
		height: 5px;
		border: solid #1d1b25;
		border-width: 0 1px 1px 0;
		transform: rotate(45deg);
		content: '';
	}
}

@media (max-width: 767px) {
	.popup {
		padding: 20px 16px 16px;
	}
}
</style>
